<script lang="ts" setup>
	import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue'
	import { Float } from '@headlessui-float/vue'
	import { twMerge } from 'tailwind-merge'
	import { ChevronDownIcon } from '@heroicons/vue/24/solid'

	defineOptions({inheritAttrs: false})

	const $props = withDefaults(defineProps<{
		label: string|number
		tag?: string
		popupClass?: string
		popupTag?: string
		slide?: boolean
		unmount?: boolean
		dropdownIcon?: string
		hideExpandIcon?: boolean
		placement?: 'top'|'top-start'|'top-end'|'right'|'right-start'|'right-end'|'bottom'|'bottom-start'|'bottom-end'|'left'|'left-start'|'left-end'
		strategy?: 'fixed'|'absolute'
		offset?: number
		shift?: number|boolean
	}>(), { unmount: false, hideExpandIcon: false, shift: false, strategy: 'fixed' })

</script>

<template>
	<Popover :as="tag" #="{ open, close }">
		<Float
			:placement="placement" :offset="offset" :strategy="strategy" :shift="shift"
			enter="transition duration-200 ease-out origin-top"
			enter-from="scale-95 opacity-0"
			enter-to="scale-100 opacity-100"
			leave="transition duration-150 ease-in"
			leave-from="scale-100 opacity-100"
			leave-to="scale-95 opacity-0"
			tailwindcss-origin-class
		>
		<PopoverButton class="gs-popover-btn cursor-pointer flex gap-2 items-center" :class="twMerge('gap-2 outline-none', $attrs.class)">
			<slot name="label">{{ label }}</slot>
			<ChevronDownIcon v-if="!hideExpandIcon" class="text-current h-5 w-5 duration-150 ui-open:rotate-180" />

		</PopoverButton>
			<PopoverPanel v-show="open"
				:as="popupTag"
				:class="twMerge('drop-shadow-lg bg-white p-2', popupClass)"
				:unmount="unmount"
			>
				<slot :close="close" />
			</PopoverPanel>
		</Float>
	</Popover>
</template>
